<ng-container *transloco="let t">
  <div class="dialog-overlay">
    <section
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      cdkTrapFocusAutoCapture>
      <!-- Header -->
      <div class="dialog-header">
        <h2 class="dialog-title" [id]="titleId">{{ t('lang.resume_dialog_title') }}</h2>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <div class="entity-row">
          <div class="entity-icon">
            @if (entityIconUrl) {
              <img
                [src]="entityIconUrl"
                [alt]="entityName"
                class="entity-icon-img" />
            } @else {
              <span class="entity-initial">{{ entityInitial }}</span>
            }
          </div>
          <div class="entity-info">
            <p class="entity-name">{{ entityName }}</p>
          </div>
        </div>

        @if (subtitleText) {
          <p class="dialog-subtitle" [id]="descriptionId">{{ subtitleText }}</p>
        } @else {
          <p class="dialog-subtitle" [id]="descriptionId">
            {{ t(subtitleKey, { entity: integrationEntityName || entityName }) }}
          </p>
        }
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <button
          #resumeButton
          type="button"
          class="primary-button"
          cdkFocusInitial
          [disabled]="loading"
          (click)="onResume()">
          @if (loading) {
            <mzic-spinner />
          }
          {{ t('lang.resume_dialog_resume_button') | uppercase }}
        </button>
        <button
          type="button"
          class="secondary-button"
          [disabled]="loading"
          (click)="onCancel()">
          {{ t('lang.resume_dialog_cancel_button') | uppercase }}
        </button>
      </div>
    </section>
  </div>
</ng-container>
